const initialState = {
    data: [],
  };
  
const odczytyWmReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ODCZYTY_WM':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default odczytyWmReducer;